import type { ICategory } from '../types'
import type { ReactElement } from 'react'

import NavLinkItem from '../NavLinkItem'

import './styles.scss'

interface Props {
  authorizations: string[]
  category: ICategory
  hoveredItems: string[]
  isCollapsed: boolean
  onHover: (value: string, level: number) => void
}

const Category = ({ authorizations, category, hoveredItems, isCollapsed, onHover }: Props): ReactElement => {
  return (
    <div className="category-container">
      <div className="category-item">
        <div className="category-title">{category.title}</div>
      </div>
      <div className="links-container">
        {category.links.map(({ authorization, ...link }) =>
          !authorization || authorizations.includes(authorization) ? (
            <NavLinkItem
              {...link}
              authorizations={authorizations}
              hoveredItems={hoveredItems}
              isCollapsed={isCollapsed}
              key={link.name}
              level={0}
              onHover={onHover}
            />
          ) : null
        )}
      </div>
    </div>
  )
}

export default Category
